import React, { useEffect, useState } from "react";
import { useScreenContext } from "../../context/ScreenContext";
import { useAxiosContext } from "../../context/AxiosContext";
import { useParams } from "react-router-dom";
import Button from "../../components/FormComponents/Button";
import AccessTemplateSelection from "../../components/BuilderComponents/AccessTemplateSelection";
import Input from "../../components/FormComponents/Input";
import Textarea from "../../components/FormComponents/Textarea";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import MultiSelectBox from "../../components/FormComponents/MultiSelectBox";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import InfoTooltip from "../../components/BuilderComponents/InfoTooltip";
import { toastError } from "../../utils/toastUtils";

const ScreenOwnerAssignment = ({ onClose }) => {
  // const { currentScreenData, setCurrentScreenData, axiosInstance, handleError, handleSuccess } = onClose;
  const { currentScreenData, setCurrentScreenData } = useScreenContext();
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();

  const [ownerAssignment, setOwnerAssignment] = useState({
    groups: currentScreenData.screen_permissions?.groups || [],
    designations: currentScreenData.screen_permissions?.designations || [],
    roles: currentScreenData.screen_permissions?.roles || [],
    access_templates: currentScreenData.screen_permissions?.access_templates || []
    // community_groups: currentScreenData.screen_permissions?.community_groups || [],
    // community_user_page_access: currentScreenData.screen_permissions?.community_user_page_access || false
  });
  const [allGroups, setAllGroups] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  // const [allCommunityGroups, setAllCommunityGroups] = useState([]);
  const [designationName, setDesignationName] = useState("");
  const [settingData, setSettingData] = useState({
    center: currentScreenData.screen_settings?.center || false,
    // show_login_information: currentScreenData.screen_settings?.show_login_information || false,
    notes: currentScreenData.screen_settings?.notes || "",
    table_id: currentScreenData.screen_settings?.table_id || "",
    table_type: currentScreenData.screen_settings?.table_type || "",
    hide_header: currentScreenData.screen_settings?.hide_header || false,
    micro_frontend_config: currentScreenData.screen_settings?.micro_frontend_config || { is_micro_frontend: false }
  });
  const [allSmData, setAllSmData] = useState([]);
  const [isPositionedScreen, setIsPositionedScreen] = useState(currentScreenData?.is_positioned_screen || false);
  const { orgId } = useParams();

  const fetchAllGroup = async () => {
    try {
      const { data } = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
      const { data: allSms } = await axiosInstance.get(`/state-machines`);
      const { data: rolesData } = await axiosInstance.get(`/user-service/role/org/${orgId}`);
      setAllSmData(allSms);
      setAllGroups(data);
      setAllRoles(rolesData);
    } catch (error) {
      handleError(error);
    }
  };
  // const fetchCommunityUserGroups = async () => {
  //   try {
  //     const { data } = await axiosInstance.get(`/community-user-groups`);
  //     setAllCommunityGroups(data);
  //   } catch (error) {
  //     handleError(error);
  //   }
  // };

  const callbackfunction = (data) => {
    const selectedDataOfId = data.map((group) => group.id);
    setOwnerAssignment({ ...ownerAssignment, groups: selectedDataOfId });
    // setSelectedGroupsData([...data]);
  };

  const rolesCallbackfunction = (data) => {
    const roleIDs = data.map((role) => role.role_code);
    setOwnerAssignment({ ...ownerAssignment, roles: roleIDs });
  };

  // const communityCallbackfunction = (data) => {
  //   const selectedDataOfId = data.map((group) => group.id);
  //   setOwnerAssignment({ ...ownerAssignment, community_groups: selectedDataOfId });
  // };

  const addDesignation = () => {
    if (designationName.trim().length < 3) {
      toastError("At least three characters required");
      return;
    }
    const array = ownerAssignment.designations || [];
    setOwnerAssignment({ ...ownerAssignment, designations: [...array, designationName] });
    setDesignationName("");
  };

  const deleteDesignation = (index) => {
    const newDesignation = ownerAssignment.designations.filter((_, i) => i !== index);
    setOwnerAssignment({ ...ownerAssignment, designations: newDesignation });
  };

  const handleAccessTemplate = (data) => {
    const copyOwnerAssignment = { ...ownerAssignment, access_templates: data };
    setOwnerAssignment(copyOwnerAssignment);
  };

  useEffect(() => {
    fetchAllGroup();
    // fetchCommunityUserGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedSettingData = { ...settingData, [name]: type === "checkbox" ? checked : value };
    setSettingData(updatedSettingData);
  };

  // const handleCommunityUserPageAccess = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   const updatedOwnderAssingment = { ...ownerAssignment, [name]: type === "checkbox" ? checked : value };
  //   setOwnerAssignment(updatedOwnderAssingment);
  // };

  const handleSelectChange = (name, value) => {
    const updatedSettingData = { ...settingData, [name]: value };
    setSettingData(updatedSettingData);
  };

  const handelTypeChange = (e) => {
    const { value } = e.target;
    const updatedSettingData = { ...settingData, table_type: value };
    setSettingData(updatedSettingData);
  };

  const getFilteredOptions = (data, tableType) => {
    const filterType = tableType === "statemachine" ? "default" : "entity";
    return data
      .filter((table) => table.sm_type === filterType)
      .map((option) => ({
        id: option.id,
        name: option.name
      }));
  };

  const handleMicroFrontendInputChange = (name, value) => {
    //clear the config when is_micro_frontend is false
    if (name === "is_micro_frontend" && !value) {
      setSettingData((prev) => ({ ...prev, micro_frontend_config: { is_micro_frontend: false } }));
      return;
    }

    setSettingData((prev) => ({ ...prev, micro_frontend_config: { ...prev.micro_frontend_config, [name]: value } }));
  };

  const handleSave = async () => {
    try {
      const { data, message } = await axiosInstance.patch(`/screens/${currentScreenData.id}`, {
        screen_permissions: ownerAssignment,
        screen_settings: settingData
      });
      handleSuccess(message);
      setCurrentScreenData({
        ...data,
        is_positioned_screen: isPositionedScreen
      });
      onClose();
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="p_3">
      <div className="builder_form">
        <MultiSelectBox
          options={allGroups}
          selectedData={ownerAssignment.groups || []}
          onChange={callbackfunction}
          label="Allowed Groups"
        />
        {/* <MultiSelectBox
          options={allCommunityGroups}
          selectedData={ownerAssignment.community_groups || []}
          onChange={communityCallbackfunction}
          label="Allowed Community Groups"
        /> */}

        <MultiSelectBox
          options={allRoles}
          selectedData={allRoles.filter((role) => ownerAssignment.roles?.includes(role.role_code))}
          onChange={rolesCallbackfunction}
          label="Allowed Roles"
        />

        <div className="builder_form mt_2">
          <div className="inline_tag_items">
            <Input
              label="Allowed designation"
              value={designationName}
              onChange={(e) => setDesignationName(e.target.value)}
            />
            <Button
              variant="secondary"
              onClick={addDesignation}
              style={{ marginTop: "20px", width: "34px", height: "34px" }}
            >
              <MaterialIcon name="add" style={{ fontSize: "20px" }} />
            </Button>
          </div>
        </div>

        <div className="selected_chip_container">
          {ownerAssignment.designations?.map((designations, index) => (
            <div key={index} className="selected_chip_items">
              {designations}{" "}
              <MaterialIcon name="close" onClick={() => deleteDesignation(index)} style={{ fontSize: "16px" }} />
            </div>
          ))}
        </div>
        <AccessTemplateSelection templates={ownerAssignment.access_templates} handleChange={handleAccessTemplate} />

        <div className="flex_column gap_3 mt_2">
          <Input
            type="checkbox"
            name="center"
            label="Center"
            checked={settingData.center}
            onChange={handleInputChange}
          />
          <Input
            type="checkbox"
            name="hide_header"
            checked={settingData?.hide_header}
            onChange={handleInputChange}
            label="Hide Header"
          />
          <Input
            type="checkbox"
            name="is_positioned_screen"
            checked={isPositionedScreen}
            onChange={(e) => setIsPositionedScreen(e.target.checked)}
            label="Is Positioned Screen"
            containerClassName="d_none"
          />

          {/* <Input
            type="checkbox"
            name="show_login_information"
            label="Show Login Information"
            checked={settingData.show_login_information}
            onChange={handleInputChange}
          /> */}
          {/* <Input
            type="checkbox"
            name="community_user_page_access"
            checked={ownerAssignment.community_user_page_access}
            onChange={handleCommunityUserPageAccess}
            label="Community user page access"
          /> */}

          <Input
            type="checkbox"
            name="is_micro_frontend"
            checked={settingData.micro_frontend_config.is_micro_frontend}
            onChange={(e) => handleMicroFrontendInputChange("is_micro_frontend", e.target.checked)}
            label="Is Micro Frontend"
          />

          {settingData.micro_frontend_config.is_micro_frontend && (
            <div className="builder_form mt_2 border_full border_radius_medium p_2">
              <Input
                label="App Name"
                placeholder="Enter the given remote application name"
                value={settingData.micro_frontend_config?.app_name}
                onChange={(e) => handleMicroFrontendInputChange("app_name", e.target.value)}
                required
              />
              <Input
                label="Entry URL"
                value={settingData.micro_frontend_config?.entry_url}
                onChange={(e) => handleMicroFrontendInputChange("entry_url", e.target.value)}
                placeholder="https://example.com/remoteEntry.js"
                required
              />
              <Input
                label="Page Path"
                value={settingData.micro_frontend_config?.page_path}
                placeholder="/home"
                onChange={(e) => handleMicroFrontendInputChange("page_path", e.target.value)}
                required
              />
            </div>
          )}

          <div className="builder_form">
            <Textarea
              label="Notes"
              value={settingData.notes}
              name="notes"
              onChange={handleInputChange}
              rows={2}
              cols={60}
            />
          </div>

          <div className="builder_form">
            <div className="d_flex gap_1">
              <label className="builder_label">Choose type</label>
              <InfoTooltip documentKey="choose_type_info" />
            </div>
            <div className="blocks_type_radio">
              <label className="builder_label d_flex gap_1 m_0 align_center">
                <Input
                  type="radio"
                  name="type"
                  value="entity"
                  checked={settingData.table_type === "entity"}
                  onChange={handelTypeChange}
                />
                entity
              </label>
              <label className="builder_label d_flex gap_1 m_0 align_center">
                <Input
                  type="radio"
                  name="type"
                  value="statemachine"
                  checked={settingData.table_type === "statemachine"}
                  onChange={handelTypeChange}
                />
                SM-Workflow
              </label>
            </div>
          </div>

          {settingData.table_type && (
            <>
              <div className="builder_form">
                <SingleSelectBox
                  selectedData={settingData.table_id}
                  options={getFilteredOptions(allSmData, settingData.table_type)}
                  onChange={(obj) => handleSelectChange("table_id", obj.id)}
                />
              </div>
            </>
          )}
        </div>

        <Button onClick={handleSave}>Save</Button>
      </div>
    </div>
  );
};

export default ScreenOwnerAssignment;
